(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw--about_sticky-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const stickyBar = document.getElementById("sticky-bar");
  const stickyWrapper = document.getElementById("sticky-wrapper");
  if (!stickyBar || !stickyWrapper) return;

  const navLinks = stickyBar.querySelectorAll("a");
  const sections = [];

  navLinks.forEach(link => {
    const id = link.getAttribute("href").substring(1);
    const el = document.getElementById(id);
    if (el) sections.push(el);
  });

  const firstSection = sections[0];
  const lastSection = sections[sections.length - 1];

  const stickyStart = stickyWrapper.offsetTop;

  function onScroll() {
    const scrollY = window.scrollY;
    const lastBottom = lastSection.offsetTop + lastSection.offsetHeight;

    // Fix until lastBottom
    if (scrollY >= stickyStart && scrollY < lastBottom - stickyBar.offsetHeight) {
      stickyBar.classList.add("fixed");
      stickyWrapper.style.height = stickyBar.offsetHeight + "px"; // reserve space
    } else {
      stickyBar.classList.remove("fixed");
      stickyWrapper.style.height = "auto"; // release smoothly
    }

    // Highlight active link
    let index = sections.length;
    while (--index && scrollY + 150 < sections[index].offsetTop) {}
    navLinks.forEach(l => l.classList.remove("active"));
    if (navLinks[index]) navLinks[index].classList.add("active");
  }

  window.addEventListener("scroll", onScroll);
  onScroll();

  // Smooth scroll
  navLinks.forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const id = this.getAttribute("href").substring(1);
      const target = document.getElementById(id);
      if (target) {
        const offset = target.offsetTop - stickyBar.offsetHeight;
        window.scrollTo({ top: offset, behavior: "smooth" });
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw--product-video-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const swiper = new Swiper(".videoSwiper", {
      spaceBetween: 16,
      navigation: {
        nextEl: ".video_slider_section .swiper-button-next",
        prevEl: ".video_slider_section .swiper-button-prev",
      },
      breakpoints: {
        310: {
          slidesPerView: 1.5,
          centeredSlides: true,
          loop: true,
        },
        480: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 4,
        },
        1200: {
          slidesPerView: 5,
        }
      }
    });

    // Play / Pause on video click
    document.querySelectorAll(".video-wrapper").forEach(wrapper => {
      const video = wrapper.querySelector("video");
      const playIcon = wrapper.querySelector(".play-icon");

      wrapper.addEventListener("click", () => {
        if (video.paused) {
          video.play();
          wrapper.classList.add("playing");
        } else {
          video.pause();
          wrapper.classList.remove("playing");
        }
      });

      // Jab video khatam ho jaye to icon firse dikh jaye
      video.addEventListener("ended", () => {
        wrapper.classList.remove("playing");
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
